// File: src/components/ui/flip-sentences.tsx

"use client";

import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

export function FlipSentences({
  sentences,
  className,
  duration = 3000, // Time each sentence is visible in milliseconds
}: {
  sentences: string[];
  className?: string;
  duration?: number;
}) {
  const [index, setIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % sentences.length);
        setIsAnimating(false);
      }, 150); // Half of the animation duration
    }, duration);

    return () => clearInterval(interval);
  }, [sentences, duration]);

  return (
    <div className={cn("relative h-6 overflow-hidden", className)}>
      <p
        className={cn(
          "font-mono text-sm text-muted-foreground transition-all duration-300 ease-in-out",
          isAnimating ? "translate-y-2 opacity-0" : "translate-y-0 opacity-100"
        )}
      >
        {sentences[index]}
      </p>
    </div>
  );
}
